import { OverlayRef } from '@angular/cdk/overlay';
import { IBbitCalendarEvent } from '@bbitgmbh/bbit.utils';
import { DateTime } from 'luxon';
import { Observable, Subject } from 'rxjs';
import { IBbitBookingOption } from '../booking.service';

export interface IBbitBookingOverlayData {
  event: IBbitCalendarEvent;
  option: IBbitBookingOption;
  events: IBbitCalendarEvent[];
  closingTime: DateTime;
}

export class BookingOverlayRef {
  private _data!: IBbitBookingOverlayData;
  private _onClose = new Subject<boolean>();
  public constructor(private _overlayRef: OverlayRef) {}

  public close(reload = false): void {
    this._overlayRef.dispose();
    this._onClose.next(reload);
    this._onClose.complete();
  }

  public setData(data: IBbitBookingOverlayData): void {
    this._data = data;
  }

  public getData(): IBbitBookingOverlayData {
    return this._data;
  }

  public observeClose(): Observable<boolean> {
    return this._onClose.asObservable();
  }
}
